import { Cartesian2 } from "../../geometry";
import { IsLocation, Bearing, Geo2 } from "../../geography";
import { EPSG3857 } from "../geography";
export class TileNavigationApi {
    constructor(navigation, metrics) {
        this._cartesianCache = Cartesian2.Zero();
        this._navigation = navigation;
        this._metrics = metrics ?? EPSG3857.Shared;
    }
    get navigationState() {
        return this._navigation;
    }
    get metrics() {
        return this._metrics;
    }
    dispose() { }
    setViewMap(center, zoom, rotation, validate) {
        if (center) {
            let lat = 0;
            let lon = 0;
            if (Array.isArray(center)) {
                lat = center.length > 0 ? center[0] : 0;
                lon = center.length > 1 ? center[1] : 0;
            }
            else {
                lat = center.lat;
                lon = center.lon;
            }
            this._navigation.center = new Geo2(lat, lon);
        }
        if (zoom !== undefined) {
            this._navigation.zoom = zoom;
        }
        if (rotation !== undefined && rotation !== this._navigation.azimuth?.value) {
            this._navigation.azimuth = new Bearing(rotation);
        }
        if (validate === undefined || validate === true) {
            this._navigation.validate();
        }
        return this;
    }
    zoomInMap(delta, validate) {
        this._navigation.zoom = this._navigation.zoom + Math.abs(delta);
        if (validate === undefined || validate === true) {
            this._navigation.validate();
        }
        return this;
    }
    zoomMap(delta, validate) {
        this._navigation.zoom = this._navigation.zoom + delta;
        if (validate === undefined || validate === true) {
            this._navigation.validate();
        }
        return this;
    }
    zoomOutMap(delta, validate) {
        this._navigation.zoom = this._navigation.zoom - Math.abs(delta);
        if (validate === undefined || validate === true) {
            this._navigation.validate();
        }
        return this;
    }
    translateUnitsMap(tx, ty, validate) {
        const m = this._metrics;
        if (this._navigation.azimuth?.value) {
            const p = this.rotatePointInv(tx, ty, this._cartesianCache);
            tx = p.x;
            ty = p.y;
        }
        const lod = Math.round(this._navigation.zoom);
        const center = this._navigation.center;
        const pixelCenterXY = m.getLatLonToPointXY(center.lat, center.lon, lod);
        pixelCenterXY.x += tx;
        pixelCenterXY.y += ty;
        this._navigation.center = m.getPointXYToLatLon(pixelCenterXY.x, pixelCenterXY.y, lod);
        if (validate === undefined || validate === true) {
            this._navigation.validate();
        }
        return this;
    }
    translateMap(lat, lon, validate) {
        if (lat) {
            let dlat;
            let dlon;
            if (Array.isArray(lat)) {
                dlat = lat.length > 0 ? lat[0] : 0;
                dlon = lat.length > 1 ? lat[1] : 0;
            }
            else if (IsLocation(lat)) {
                dlat = lat.lat;
                dlon = lat.lon;
            }
            else {
                dlat = lat;
                dlon = lon ?? 0;
            }
            const center = this._navigation.center;
            this._navigation.center = new Geo2(center.lat + dlat, center.lon + dlon);
            if (validate === undefined || validate === true) {
                this._navigation.validate();
            }
        }
        return this;
    }
    rotateMap(r, validate) {
        this._navigation.azimuth = new Bearing(this._navigation.azimuth.value + r);
        if (validate === undefined || validate === true) {
            this._navigation.validate();
        }
        return this;
    }
    rotatePointInv(x, y, target) {
        const r = target || Cartesian2.Zero();
        const azimuth = this._navigation.azimuth;
        r.x = x * azimuth.cos + y * azimuth.sin;
        r.y = -x * azimuth.sin + y * azimuth.cos;
        return r;
    }
}
//# sourceMappingURL=tiles.navigation.api.js.map